export const baseURL = "/employer-dashboard";
export const managedCompanyProfileIdParam = "managed_company_profile_id";

// Set up
export const autopaySetupGuidesURL = `${baseURL}/setup-autopay-guides`;

// Benefits URLs
export const addNewEmployeeURL = `${baseURL}/add-new-employee`;
export const addNewEmployeeConfirmationURL = `${addNewEmployeeURL}/confirm`;
export const addNewEmployeeSuccessfulURL = `${addNewEmployeeURL}/success`;
export const manageEmployeesURL = `${baseURL}/manage-employees`;
export const employeeStatusURL = `${baseURL}/employee-status`;
export const requestInvoiceURL = `${baseURL}/request-invoices`;
export const costOfNewHireURL = `${baseURL}/cost-of-new-hire`;
export const payBillURL = `${baseURL}/pay-my-bills`;
export const cancelCompanyPolicyURL = `${baseURL}/cancel-company-policy`;
export const healthPlanDetailsURL = `${baseURL}/health-plan-details`;
export const policyManagementURL = `${baseURL}/manage-policy`;
// Not linked from the dashboard: reachable only by visiting the URL while it is built.
export const contributionWizardURL = `${baseURL}/contribution-wizard`;
export const healthPlanURL = (type: string, id: string) => `${baseURL}/health-plan-details/${type}/${id}`;

// Benefits - Partner Add
export const partnerAddNewEmployeeURL = `${baseURL}/partner-add-employee-confirmation`;
export const partnerDenyBenefitsSuccessURL = `${partnerAddNewEmployeeURL}/deny-benefits`;
export const partnerApproveBenefitsSuccessURL = `${partnerAddNewEmployeeURL}/approve-benefits`;
export const partnerWaitingOnRenewalURL = `${partnerAddNewEmployeeURL}/waiting-on-renewal`;
export const ajaxPartnerAddEmployeeOptionsURL = (employeeHashId: string) => `${baseURL}/ajax-partner-add-employee-options?employee_hash_id=${employeeHashId}`;
export const ajaxPartnerAddEmployeeDenyBenefitsURL = (employeeHashId: string) =>
  `${baseURL}/ajax-partner-add-employee-deny-benefits?employee_hash_id=${employeeHashId}`;
export const ajaxPartnerAddEmployeeConfirmBenefitsURL = (employeeHashId: string) =>
  `${baseURL}/ajax-partner-add-employee-confirm-benefits?employee_hash_id=${employeeHashId}`;

// Benefits - Renewal
export const renewalName = "/employer-renewal";
export const renewalURL = `/employer-renewal`;
export const renewalOverviewName = "/employer-renewal/overview";
export const renewalOverviewURL = `/employer-renewal/overview`;

// Broker - Renewal
export const benAdminOpenEnrollmentSetupURL = "/benefits-administration/open-enrollment-setup";
export const benAdminRenewalURL = "/benefits-administration/renewal";

// Settings
export const companyInformationURL = `${baseURL}/company-information`;
export const addressDetailsURL = `${companyInformationURL}/address-details`;
export const companyDetailsURL = `${companyInformationURL}/company-details`;
export const primaryContactURL = `${companyInformationURL}/primary-contact`;
export const bankingInformationURL = `${companyInformationURL}/banking-information`;
export const addAdministratorsURL = `${companyInformationURL}/manage-admins`;

// Settings & Set up (this url is used in both menu sections)
export const managePayrollURL = `${baseURL}/manage-payroll`;
export const integrationsURL = `${baseURL}/integrations`;
export const intuitPostConnectURL = `${baseURL}/integrations/intuit/connected`;

// Reference
export const getHelpURL = "/support";
export const partnerNetworkAndDealsURL = "http://info.simplyinsured.com/partners/";

// Top Bar links
export const adminURL = "/admin";
export const companyDashboardTopBarLink = (companyIDToken: string) => `/company/${companyIDToken}/small-group/employer-dashboard`;

export const switchDashboardTopBarLink = `/small-group/switch-profile`;

export const switchCompanyURL = `/switch-company`;

// Utils pages
export const successName = `${baseURL}/success`;
export const successURL = (formName: string | null | undefined) => `${successName}${formName ? `?formName=${formName}` : ""}`;
